import _implicitStylesheets from "./expandableSection.css";
import _implicitScopedStylesheets from "./expandableSection.scoped.css?scoped=true";
import _axBar from "ax/bar";
import _wdsButton from "wds/button";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "axwp-expandable-section__toggle": true
  },
  key: 1
};
const stc1 = {
  classMap: {
    "axwp-expandable-section__content": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "axwp-expandable-section__inner-container": true
  },
  key: 4
};
const stc3 = {
  attrs: {
    "name": "content"
  },
  key: 5
};
const stc4 = [];
const stc5 = {
  classMap: {
    "axwp-expandable-section__more-button": true
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, s: api_slot} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    key: 0
  }, [api_element("div", stc0, [api_custom_element("ax-bar", _axBar, {
    props: {
      "text": $cmp.toggleButtonText,
      "variant": "secondary",
      "icon": $cmp.toggleIcon
    },
    key: 2
  })]), api_element("div", stc1, [api_element("div", stc2, [api_slot("content", stc3, stc4, $slotset), $cmp.hasReadMoreLink ? api_element("div", stc5, [api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.readMoreLink,
      "variant": "secondary",
      "label": $cmp.readMoreLinkText,
      "target": "_blank"
    },
    key: 7
  })]) : null])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["content"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6ldckcm49c1";
tmpl.legacyStylesheetToken = "undefined-_expandableSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
